import { StockDerivative } from "./StockDerivativeModel";
import { StockFixedIncome } from "./StockFixedIncomeModel";
import { StockFunds } from "./StockFundsModel";
import { StockOtherAsset } from "./StockOtherAssetModel";
import { StockSwapCetip } from "./StockSwapCetipModel";
import { StockVariableIncome } from "./StockVariableIncomeModel";

export class AllStockModel {
  stockFund: StockFunds;
  stockFixedIncome: StockFixedIncome;
  stockVariableIncome: StockVariableIncome;
  stockOtherAsset: StockOtherAsset;
  stockDerivative: StockDerivative;
  stockSwapCetip: StockSwapCetip;
}
